module.exports = __webpack_public_path__ + "media/images/pages/img_gourmet_01-7b316b1b245edbd9bbb1a0a838f47eec.jpg";